import React, { useState } from "react";
import { postDonationEntry } from "../services/apiservice"; // Import API function
import "./Donation.scss";
import donationImage from "../assets/images/qrcbackground.png";
import successGif from "../assets/images/namastehands.jpg"; // Import your success GIF
import donationvideo from "../../src/assets/videos/donationvideo.mp4"


const DonationPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    amount: "",
    donationtype: "",
    transactionid: "",
    pannumber: ""
  });

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false); // State for success popup

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {

    e.preventDefault();
    setMessage(null);
    setError(null);

    try {
      const response = await postDonationEntry(formData);
      setShowPopup(true); // Show success popup

      // Hide popup after 5 seconds
      setTimeout(() => {
        setShowPopup(false);
      }, 10000);

      setFormData({ name: "", mobile: "", amount: "", donationtype: "", transactionid: "" }); // Reset form
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <div className="donationcontainer">
    <div className="donation-container">
      <div className="background-image"></div>
      <div className="pratishthavideo">
        <video controls autoPlay loop >
          <source src={donationvideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="content">
        <div className="header">
          <h1>देणगी</h1>
          <p className="donation-text" style={{fontSize:"16px"}}>
            आपणास कोणतीही सेवा करायची असल्यास अथवा काही योगदान करायचे असल्यास अथवा पूजेसाठी
            यजमान व्हायचे असल्यास संपर्क करू शकता अथवा थेट मंदिराचे बँक खात्यामध्ये स्वेच्छेने
            समर्पण करू शकता.
          </p>
        </div>

        {/* Success Popup */}
        {showPopup && (
          <div className="success-popup">
            <img src={successGif} alt="Success" style={{ width: "300px" }} />
            <p>देणगी दिल्याबद्दल धन्यवाद!</p>
          </div>
        )}

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        {/* Donation Form */}
        {!showPopup && (
          <div className="formandvideo">
            <form onSubmit={handleSubmit} className="donation-form">
              <input type="text" name="name" placeholder="नाव" required value={formData.name} onChange={handleChange} />
              <input type="text" name="mobile" placeholder="मोबाईल" required value={formData.mobile} onChange={handleChange} />

              <select name="donationtype" required value={formData.donationtype} onChange={handleChange} className="donation-dropdown">
                <option value="" disabled hidden>
                  देणगीचा प्रकार निवडा
                </option>
                <option value="Annadan">अन्नदान</option>
                <option value="Pranpratisthapana">प्राणप्रतिष्ठापना</option>
              </select>

              <input type="text" name="pannumber" placeholder="पॅन नंबर" value={formData.pannumber} onChange={handleChange} />
              <input type="number" name="amount" placeholder="रक्कम" required value={formData.amount} onChange={handleChange} />
              {formData.amount && (<input type="text" name="transactionid" placeholder="Transaction ID" value={formData.transactionid} onChange={handleChange} />)}
              {formData.amount && (
                <img src={donationImage} alt="Donation QR" className="donation-image qr-visible" />
              )}

              <button type="submit">Donate</button>
            </form>
          </div>)}

        {/* QR Code Image */}
        <img src={donationImage} alt="Donation QR" className="donation-image" style={{ width: "300px" }} />
      </div>
    </div>
    <div className="mobile-donation-container">
    <div className="background-image"></div>
      
      <div className="content">
        <div className="header">
          <h1>देणगी</h1>
          <p className="donation-text" style={{fontSize:"16px"}}>
            आपणास कोणतीही सेवा करायची असल्यास अथवा काही योगदान करायचे असल्यास अथवा पूजेसाठी
            यजमान व्हायचे असल्यास संपर्क करू शकता अथवा थेट मंदिराचे बँक खात्यामध्ये स्वेच्छेने
            समर्पण करू शकता.
          </p>
        </div>

        {/* Success Popup */}
        {showPopup && (
          <div className="success-popup">
            <img src={successGif} alt="Success" style={{ width: "300px" }} />
            <p>देणगी दिल्याबद्दल धन्यवाद!</p>
          </div>
        )}

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        {/* Donation Form */}
        {!showPopup && (
          <div className="formandvideo">
            <form onSubmit={handleSubmit} className="donation-form">
              <input type="text" name="name" placeholder="नाव" required value={formData.name} onChange={handleChange} />
              <input type="text" name="mobile" placeholder="मोबाईल" required value={formData.mobile} onChange={handleChange} />

              <select name="donationtype" required value={formData.donationtype} onChange={handleChange} className="donation-dropdown">
                <option value="" disabled hidden>
                  देणगीचा प्रकार निवडा
                </option>
                <option value="Annadan">अन्नदान</option>
                <option value="Pranpratisthapana">प्राणप्रतिष्ठापना</option>
              </select>

              <input type="text" name="pannumber" placeholder="पॅन नंबर" value={formData.pannumber} onChange={handleChange} />
              <input type="number" name="amount" placeholder="रक्कम" required value={formData.amount} onChange={handleChange} />
              {formData.amount && (<input type="text" name="transactionid" placeholder="Transaction ID" value={formData.transactionid} onChange={handleChange} />)}
              {formData.amount && (
                <img src={donationImage} alt="Donation QR" className="donation-image qr-visible" />
              )}

              <button type="submit">Donate</button>
            </form>
          </div>)}

        {/* QR Code Image */}
        <img src={donationImage} alt="Donation QR" className="donation-image" style={{ width: "300px" }} />
      </div>
      <div className="pratishthavideo">
        <video controls autoPlay loop >
          <source src={donationvideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    </div>
    
  );
};

export default DonationPage;
